// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"d40dd16a","106":"df85cfa5","262":"f346ddd9","438":"0907f74c","626":"25e09da2","720":"14ab25e4","895":"82a70bd7"}[chunkId] + ".chunk.js";
};